import * as React from "react";
import {Grid2 as Grid} from "@mui/material";
import {CompanySignUpDTO} from "@/api/data-contracts";
import {ChangeHandler} from "@/lib/modelstate";
import {ErrorsShape} from "@/lib/utils";
import {CardEx} from "@/lib/components/CardEx";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {Constants} from "@/api/constants";
import {useTranslation} from "react-i18next";
import {CompanyI18N} from "@/translations";

export const BankDetailsForm = ({
    model,
    errors,
    onChange
}: {
    model?: CompanySignUpDTO;
    onChange: ChangeHandler;
    errors: ErrorsShape<CompanySignUpDTO>;
}) => {
    const { t } = useTranslation();

    return (
            <CardEx title={t(CompanyI18N.form.page.bankConnectionTitle)}>
            <Grid container direction="column" spacing={3} width="100%">
                <Grid size={{ sm: 6, md: 4, lg: 3 }}>
                    <StringInputField
                        name="bankName"
                        value={model?.bankName}
                        label={t(CompanyI18N.form.field.bankName)}
                        error={errors?.bankName}
                        maxChars={Constants.BANKNAME_LENGTH_MAX}
                        onChange={onChange}
                        multiline={true}
                    />
                </Grid>
                <Grid size={{ sm: 6, md: 4, lg: 3 }}>
                    <StringInputField
                        name="iban"
                        value={model?.iban}
                        label={t(CompanyI18N.form.field.iban)}
                        error={errors?.iban}
                        maxChars={Constants.IBAN_LENGTH_MAX}
                        onChange={onChange}
                        multiline={true}
                    />
                </Grid>
                <Grid size={{ sm: 6, md: 4, lg: 3 }}>
                    <StringInputField
                        name="bic"
                        value={model?.bic}
                        label={t(CompanyI18N.form.field.bic)}
                        error={errors?.bic}
                        maxChars={Constants.BIC_LENGTH_MAX}
                        onChange={onChange}
                        multiline={true}
                    />
                </Grid>
                <Grid size={{ sm: 12, md: 6, lg: 4 }}>
                    <StringInputField
                        name="paymentTerms"
                        value={model?.paymentTerms}
                        label={t(CompanyI18N.form.field.paymentTerms)}
                        error={errors?.paymentTerms}
                        maxChars={Constants.PAYMENT_TERMS_LENGTH_MAX}
                        onChange={onChange}
                        multiline={true}
                    />
                </Grid>
            </Grid>
        </CardEx>
    );
};
